import EmployeeMain from "../types/employee";
import { EmployeeForm } from "../components/common/types";

/**
 * Extract numeric IDs from array of objects
 */
const mapIds = <T extends { id: number }>(arr?: T[]): number[] => {
    if (!Array.isArray(arr)) return [];
    return arr.map(item => item.id);
};

const mapLocationIds = <T extends { location_id: number }>(arr?: T[]): number[] => {
    if (!Array.isArray(arr)) return [];
    return arr.map(item => item.location_id);
};

// const mapAccompaniedIds = <T extends { accompanied_id: number }>(arr?: T[]): number[] => {
//     if (!Array.isArray(arr)) return [];
//     return arr.map(item => item.accompanied_id);
// };


/**
 * Convert EmployeeMain → EmployeeForm (for edit forms)
 */
export const mapEmployeeMainToForm = (
    employee: EmployeeMain
): EmployeeForm => {
    return {
        id: employee.id,
        tenant_id: employee.tenant_id,
        user_id: employee.user?.id ?? employee.user_id ?? 0,
        country_id: employee.country_id ?? employee.country?.id ?? 0,
        zone_id: employee.zone_id ?? employee.zone?.id ?? 0,
        head_quarter_id: employee.head_quarter_id ?? 0,
        head_quarters: mapIds(employee.head_quarters as any ?? []),
        assigned_locations: mapIds(employee.assigned_locations as any ?? []),
        out_station_hqs: mapIds(employee.out_station_hqs as any ?? []),
        designation_id: employee.designation_id ?? employee.designation?.id ?? 0,

        ex_stations: mapLocationIds(employee.ex_stations),
        out_stations: mapLocationIds(employee.out_stations),
        // accompanied_employee: mapAccompaniedIds(employee.accompanied_employee),

        name: employee.user?.name ?? employee.name ?? "",
        email: employee.user?.email ?? employee.email ?? "",
        code: employee.code ?? "",
        photo: employee.photo ?? "",

        gender: employee.gender ?? "",
        work_type: employee.work_type ?? "",
        marital_status: employee.marital_status ?? "",
        anniversary: employee.anniversary ?? "",

        mobile: employee.mobile ?? "",
        alternate_mobile: employee.alternate_mobile ?? "",
        current_address: employee.current_address ?? "",
        permanent_address: employee.permanent_address ?? "",
        zip: employee.zip ?? "",

        assigned_to: employee.assigned_to?.id ?? undefined,
        additional_supervisor: employee.additional_supervisor?.supervisor_id ?? undefined,

        doj: employee.doj ?? "",
        dob: employee.dob ?? "",
        qualification: employee.qualification ?? "",
        adhar_no: employee.adhar_no ?? "",
        pan_no: employee.pan_no ?? "",
        uan: employee.uan ?? "",
        dl_no: employee.dl_no ?? "",
        dl_expiry_date: employee.dl_expiry_date ?? "",
        blood_group: employee.blood_group ?? "",

        da_hq: employee.da_hq ?? 0,
        da_ex: employee.da_ex ?? 0,
        da_out: employee.da_out ?? 0,
        da_rhq: employee.da_rhq ?? 0,
        da_transit: employee.da_transit ?? 0,
        da_other: employee.da_other ?? 0,
        per_km: employee.per_km ?? 0,

        banking_name: employee.banking_name ?? "",
        account_number: employee.account_number ?? "",
        ifsc_code: employee.ifsc_code ?? "",
        beneficiary_id: employee.beneficiary_id ?? "",
        bank_name: employee.bank_name ?? "",
        branch_name: employee.branch_name ?? "",
        nominee_name: employee.nominee_name ?? "",
        annual_income: employee.annual_income ?? "",

        created_at: employee.created_at ?? "",
        updated_at: employee.updated_at ?? "",

        user: employee.user,
    };
};
